import React from 'react'
import { Nav } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

function CheckoutSteps({ step1, step2, step3, step4 }) {

    return (
        <Nav className='justify-content-center mb-4'>
            <Nav.Item>
                {step1 ? (
                    <LinkContainer to='/adjustments'>
                        <Nav.Link>Adjustments </Nav.Link>
                    </LinkContainer>
                ) : (
                        <Nav.Link disabled>Adjustments</Nav.Link>
                    )}
            </Nav.Item>



            <Nav.Item>
                {step2 ? (
                    <LinkContainer to='/configure'>
                        <Nav.Link>Configure</Nav.Link>
                    </LinkContainer>
                ) : (
                        <Nav.Link disabled>Configure</Nav.Link>
                    )}
            </Nav.Item>
            <Nav.Item>
                {step3 ? (
                    <LinkContainer to='/clientinfo'>
                        <Nav.Link>Customer Details</Nav.Link>
                    </LinkContainer>
                ) : (
                        <Nav.Link disabled>Customer Details</Nav.Link>
                    )}
            </Nav.Item>

            <Nav.Item>
                {step4 ? (
                    <LinkContainer to='/placequote'>
                        <Nav.Link>Save Quote</Nav.Link>
                    </LinkContainer>
                ) : (
                        <Nav.Link disabled>Save Quote</Nav.Link>
                    )}
            </Nav.Item>
        </Nav>
    )
}

export default CheckoutSteps
